import createTopFieldSelectorFactory from "../../../../helpers/createTopFieldSelectorFactory"

const fetchSurveysState = state => state.fetchSurveys

const createTopFieldSelector = createTopFieldSelectorFactory(fetchSurveysState)

export const getSurveys = createTopFieldSelector("surveys")

export const getIsLoading = createTopFieldSelector("isLoading")
